import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const customerUser = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
            width: 150
        },
        {
            title: '客户姓名',
            dataIndex: 'contactName',
            key: 'contactName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.contactName || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '电话号码',
            dataIndex: 'phone',
            key: 'phone',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.phone || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '邮箱',
            dataIndex: 'email',
            key: 'email',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.email || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '剩余金额',
            dataIndex: 'remainingAmount',
            key: 'remainingAmount',
            scopedSlots: {
                filterDropdown: 'filterAmount',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'remainingAmount'
            },
            filteredValue: filteredInfo.remainingAmount || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '单位名称',
            dataIndex: 'customerCompany.companyName',
            key: 'companyName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.companyName || []
        },
        {
            title: '课题组',
            dataIndex: 'researchGroup.principalInvestigator',
            key: 'groupName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.groupName || []
        },
        {
            title: '对应销售姓名',
            dataIndex: 'sales.name',
            key: 'salesperson',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.salesperson || []
        },
        {
            title: '创建人',
            dataIndex: 'createBy',
            key: 'createBy',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.createBy || []
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
    ]
}
